// place client specific code here
var clientSpecific = {
  init: function($) {

  }
};

var cli_forms = {
  init: function($) {
    // // enable datepicker field
    // flatpickr('.date-field', {
    //   altInput: true,
    //   altFormat: "d-m-Y",
    //   dateFormat: "d-m-Y",
    //   minDate: new Date().fp_incr(3), // 1 day from now
    //   "disable": [
    //       function(date) {
    //           // return true to disable
    //           // disable weekend
    //           return (date.getDay() === 0 || date.getDay() === 6);
    //
    //       }
    //   ],
    //   "locale": {
    //       "firstDayOfWeek": 1 // start week on Monday
    //   }
    // });
    //
    // // scroll to message after submit
    // $('.wpcf7-form').on('submit', function() {
    //   var $scrollToElm = $('.wpcf7-submit', this);
    //
    //   var scrollTo = $scrollToElm.offset().top + 80;
    //
    //   $('html, body').stop().animate( {
    //     'scrollTop': scrollTo
    //   }, 900, 'swing');
    // });

  }
}

jQuery( document ).ready(function($) {
    // cli_forms.init($);
    // clientSpecific.init($);
});
